<div class="sidebar-container">
  <div class="sidebar-header">
    <a href="/" class="d-flex align-items-center text-decoration-none">
      <app-logo></app-logo>
      <span class="fs-4 ms-2">TaskTrackerPro</span>
    </a>
  </div>

  <ul class="nav nav-pills flex-column mb-auto" *ngIf="currentUser$ | async as user">
    <!-- Administrator Links -->
    <ng-container *ngIf="user?.role === 'Administrator'">
      <li class="nav-item">
        <a routerLink="/admin/dashboard" class="nav-link" routerLinkActive="active">
          <i class="bi bi-grid-fill me-2"></i>{{ 'SIDEBAR.DASHBOARD' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/coordinators" class="nav-link" routerLinkActive="active">
          <i class="bi bi-person-video3 me-2"></i>{{ 'SIDEBAR.TECHNICIANS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/tasks" class="nav-link" routerLinkActive="active">
          <i class="bi bi-card-checklist me-2"></i>{{ 'SIDEBAR.TASKS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/users" class="nav-link" routerLinkActive="active">
          <i class="bi bi-people-fill me-2"></i>{{ 'SIDEBAR.USERS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/reports" class="nav-link" routerLinkActive="active">
          <i class="bi bi-bar-chart-line-fill me-2"></i>{{ 'SIDEBAR.REPORTS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link collapsed" data-bs-toggle="collapse" href="#catalogs-submenu" role="button" aria-expanded="false" aria-controls="catalogs-submenu">
          <i class="bi bi-book-fill me-2"></i>{{ 'SIDEBAR.CATALOGS' | translate }}
        </a>
        <div class="collapse" id="catalogs-submenu">
          <ul class="nav flex-column ms-4">
            <li class="nav-item">
              <a routerLink="/admin/catalogs/products" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.PRODUCTS' | translate }}</a>
            </li>
            <li class="nav-item">
              <a routerLink="/admin/catalogs/services" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.SERVICES' | translate }}</a>
            </li>
            <li class="nav-item">
              <a routerLink="/admin/catalogs/units" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.UNITS' | translate }}</a>
            </li>
            <li class="nav-item">
              <a routerLink="/admin/catalogs/zones" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.ZONES' | translate }}</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/chat" class="nav-link" routerLinkActive="active">
          <i class="bi bi-chat-dots-fill me-2"></i>{{ 'SIDEBAR.CHAT' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/notifications" class="nav-link" routerLinkActive="active">
          <i class="bi bi-bell-fill me-2"></i>{{ 'SIDEBAR.NOTIFICATIONS' | translate }}
          <ng-container *ngIf="unreadCount$ | async as unreadCount">
            <span *ngIf="unreadCount > 0" class="badge bg-danger ms-auto">{{ unreadCount }}</span>
          </ng-container>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/settings" class="nav-link" routerLinkActive="active">
          <i class="bi bi-gear-fill me-2"></i>{{ 'SIDEBAR.SETTINGS' | translate }}
        </a>
      </li>
    </ng-container>

    <!-- Coordinator Links -->
    <ng-container *ngIf="user?.role === 'Coordinator'">
      <li class="nav-item">
        <a routerLink="/coordinator/dashboard" class="nav-link" routerLinkActive="active">
          <i class="bi bi-grid-fill me-2"></i>{{ 'SIDEBAR.DASHBOARD' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/coordinator/tasks" class="nav-link" routerLinkActive="active">
          <i class="bi bi-card-checklist me-2"></i>{{ 'SIDEBAR.TASKS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/coordinator/coordinators" class="nav-link" routerLinkActive="active">
          <i class="bi bi-person-video3 me-2"></i>{{ 'SIDEBAR.TECHNICIANS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link collapsed" data-bs-toggle="collapse" href="#catalogs-submenu-coord" role="button" aria-expanded="false" aria-controls="catalogs-submenu-coord">
          <i class="bi bi-book-fill me-2"></i>{{ 'SIDEBAR.CATALOGS' | translate }}
        </a>
        <div class="collapse" id="catalogs-submenu-coord">
          <ul class="nav flex-column ms-4">
            <li class="nav-item">
              <a routerLink="/coordinator/catalogs/products" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.PRODUCTS' | translate }}</a>
            </li>
            <li class="nav-item">
              <a routerLink="/coordinator/catalogs/services" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.SERVICES' | translate }}</a>
            </li>
            <li class="nav-item">
              <a routerLink="/coordinator/catalogs/units" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.UNITS' | translate }}</a>
            </li>
            <li class="nav-item">
              <a routerLink="/coordinator/catalogs/zones" class="nav-link" routerLinkActive="active">{{ 'SIDEBAR.ZONES' | translate }}</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item">
        <a routerLink="/coordinator/chat" class="nav-link" routerLinkActive="active">
          <i class="bi bi-chat-dots-fill me-2"></i>{{ 'SIDEBAR.CHAT' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/notifications" class="nav-link" routerLinkActive="active">
          <i class="bi bi-bell-fill me-2"></i>{{ 'SIDEBAR.NOTIFICATIONS' | translate }}
          <ng-container *ngIf="unreadCount$ | async as unreadCount">
            <span *ngIf="unreadCount > 0" class="badge bg-danger ms-auto">{{ unreadCount }}</span>
          </ng-container>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/coordinator/settings" class="nav-link" routerLinkActive="active">
          <i class="bi bi-gear-fill me-2"></i>{{ 'SIDEBAR.SETTINGS' | translate }}
        </a>
      </li>
    </ng-container>

    <!-- Technician Links -->
    <ng-container *ngIf="user?.role === 'Technician'">
      <li class="nav-item">
        <a routerLink="/technician/dashboard" class="nav-link" routerLinkActive="active">
          <i class="bi bi-speedometer2 me-2"></i>{{ 'SIDEBAR.MY_TASKS' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/technician/chat" class="nav-link" routerLinkActive="active">
          <i class="bi bi-chat-dots-fill me-2"></i>{{ 'SIDEBAR.CHAT' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/notifications" class="nav-link" routerLinkActive="active">
          <i class="bi bi-bell-fill me-2"></i>{{ 'SIDEBAR.NOTIFICATIONS' | translate }}
          <ng-container *ngIf="unreadCount$ | async as unreadCount">
            <span *ngIf="unreadCount > 0" class="badge bg-danger ms-auto">{{ unreadCount }}</span>
          </ng-container>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/technician/settings" class="nav-link" routerLinkActive="active">
          <i class="bi bi-gear-fill me-2"></i>{{ 'SIDEBAR.SETTINGS' | translate }}
        </a>
      </li>
    </ng-container>
  </ul>

  <div class="sidebar-footer" *ngIf="currentUser$ | async as user">
    <hr>
    <div class="user-profile">
      <img [src]="user.photoURL || 'assets/default-avatar.png'" alt="User Avatar" class="user-avatar">
      <div class="user-info">
        <strong class="user-name">{{ user.displayName || 'User' }}</strong>
        <span class="user-role">{{ user.role }}</span>
      </div>
      <div class="logout-button">
        <a (click)="logout()" class="btn btn-icon" [attr.aria-label]="'ARIA_LABELS.LOGOUT' | translate">
          <i class="bi bi-box-arrow-right"></i>
        </a>
      </div>
    </div>
  </div>
</div>
